import React, { memo } from "react";
import { SvgIcon } from "@mui/material";
import { IIconProps } from "@/models";

const ArrowDownUpIcon = ({ sx, ...otherProps }: IIconProps) => {
  return (
    <SvgIcon
      viewBox="0 0 19 23"
      sx={{ fontSize: "inherit", fill: "none", ...sx }}
      {...otherProps}
    >
      <path
        d="M9.54382 16.7391L5.83663 13.8696L13.251 13.8696L9.54382 16.7391Z"
        fill="currentColor"
      />
      <path
        d="M9.54382 6.21741L13.251 9.08697L5.83663 9.08697L9.54382 6.21741Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};

export default memo(ArrowDownUpIcon);
